<template>
  <div class="user-form user-login-form">
    <h2>{{$t('登录')}}</h2>
    <div class="form login-form">
      <div class="form-field field-account">
        <div class="addion">
          <i class="fa fa-user"></i>
        </div>
        <input v-model="account" type="text" :placeholder="$t('请输入已有账号')">
      </div>
      <div class="form-field field-account">
        <div class="addion">
          <i class="fa fa-lock"></i>
        </div>
        <input v-model="password" type="password" :placeholder="$t('请输入密码')">
      </div>
    </div>
    <div class="text-error" v-show="errors" v-for="(error, key) in errors" :key="key">* {{error}}</div>
    <div class="actions">
      <SubmitButton class="btn btn-next" :valid="valid" :submit="handleLogin" :errors.sync="errors">{{$t('登录')}}</SubmitButton>
    </div>
    <div class="footer flex-row">
      <div class="text-muted" style="display: none;" @click="$emit('dest', 'forget')">{{$t('忘记密码')}}</div>
      <div class="flex1"></div>
      <div class="text-primary" @click="$emit('dest', 'register')">{{$t('注册')}}</div>
    </div>
  </div>
</template>

<script>
import apiUser from '@/api/user'
import SubmitButton from '../SubmitButton'

export default {
  name: 'Login',
  components: { SubmitButton },
  data() {
    return {
      account: '',
      password: '',
      errors: [],
    }
  },
  computed: {
    valid() {
      return this.account && this.password
    },
  },
  methods: {
    handleLogin() {
      return apiUser.login({account: this.account, password: this.password}).then(res => {
        this.$emit('login', res)
      })
    }
  }
}
</script>